import React from 'react'
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import SubmitScreen from '../components/body/submitScreen/SubmitScreen';

function Error() {
    return (
        <>
            <Header headerText="Twoja zielona energia"/>
            <SubmitScreen success={false} />
            <Footer />
        </>
    )
}

export default Error
